// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/feature/hotel/booking_urgency.proto (package carmen, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file proto/model/feature/hotel/booking_urgency.proto.
 */
export const file_proto_model_feature_hotel_booking_urgency = /*@__PURE__*/
  fileDesc("Ci9wcm90by9tb2RlbC9mZWF0dXJlL2hvdGVsL2Jvb2tpbmdfdXJnZW5jeS5wcm90bxIGY2FybWVuIqIBCg5Cb29raW5nVXJnZW5jeRIYChBsb3dfYXZhaWxhYmlsaXR5GAEgASgIEhwKFGF2YWlsYWJpbGl0eV9tZXNzYWdlGAIgASgJEhMKC2hpZ2hfZGVtYW5kGAMgASgIEhYKDmRlbWFuZF9tZXNzYWdlGAQgASgJEhQKDHByaWNlX3Jpc2luZxgFIAEoCBIVCg1wcmljZV9tZXNzYWdlGAYgASgJQjZaNGdpdGh1Yi5jb20veXVuYWNhYmEvY2FybWVuL3Byb3RvL21vZGVsL2ZlYXR1cmUvaG90ZWxiBnByb3RvMw");

/**
 * Describes the message carmen.BookingUrgency.
 * Use `create(BookingUrgencySchema)` to create a new message.
 */
export const BookingUrgencySchema = /*@__PURE__*/
  messageDesc(file_proto_model_feature_hotel_booking_urgency, 0);

